import { CommonStrings } from "../../../../../common/classes/CommonStrings";
import { SMSRouteDefs } from "../../../routing/SMSRouteDefs";

export class SchnittstellendatenRouteDefs {
  public static FEATURE_PATH = "schnittstellendaten";
  public static PARAM_ID = "Id";
  public static PARAM_VERSION_ENTITY_ID = "versionEntityId";

  public static FKT_LIST_PATH = `home`;
  public static VERSIONEN_ANZEIGEN_PATH = `versionen-anzeigen`;
  public static VERSIONEN_DETAIL_PATH = `versionen-detail/:versionEntityId`;
  public static HANDBUCH_PATH = `handbuch`;

  public static BASE_PATH = `${this.FEATURE_PATH}`;
  public static FKT_LIST_FQ_PATH = `${this.BASE_PATH}/${this.FKT_LIST_PATH}`;
  public static VERSIONEN_ANZEIGEN_FQ_PATH = `${this.BASE_PATH}/${this.VERSIONEN_ANZEIGEN_PATH}`;
  public static VERSIONEN_DETAIL_FQ_PATH = `${this.BASE_PATH}/${this.VERSIONEN_DETAIL_PATH}`;
  public static HANDBUCH_FQ_PATH = `${this.BASE_PATH}/${this.HANDBUCH_PATH}`;

  public static getFQR = () => this.BASE_PATH;
  public static getFQRFktList = () => this.FKT_LIST_FQ_PATH;
  public static getFQRVersionenAnzeigen = () => this.VERSIONEN_ANZEIGEN_FQ_PATH;
  public static getFQRHandbuch = () => this.HANDBUCH_FQ_PATH;
  
  public static getVersionenDetail = (versionEntityId: string) =>
    `${this.BASE_PATH}/versionen-detail/${versionEntityId}`;
}
